import i18n from '@i18next/i18n';
import { AnimType, STTLTimeNodePresetClassType } from '@tencent/slide-sdk-model';
// 批量动画一级菜单id
export const BATCH_ANIMATION_ID = {
    BATCH_ADD_ANIMATION: 'batch_add_animation',
    BATCH_DELETE_ANIMATION: 'batch_delete_animation',
};
// 批量动画一级菜单文本
export const BATCH_ANIMATION_TEXT = {
    BATCH_ANIMATION: i18n.t('批量动画'),
    BATCH_ADD_ANIMATION: i18n.t('批量添加动画'),
    BATCH_DELETE_ANIMATION: i18n.t('批量删除动画'),
};
// 批量删除动画二级菜单id
export const BATCH_DELETE_ANIMATION_MENU_ID = {
    DELETE_SELECTED_ELEMENT_ANIMATION: 'delete_selected_element_animation',
    DELETE_SELECTED_PAGE_ANIMATION: 'delete_selected_page_animation',
    DELETE_ALL_PAGE_ANIMATION: 'delete_all_page_animation',
    MORE_DELETE_OPTION: 'more_delete_option',
};
// 批量删除动画二级菜单文本
export const BATCH_DELETE_ANIMATION_MENU_TEXT = {
    DELETE_SELECTED_ELEMENT_ANIMATION: i18n.t('删除选中元素动画'),
    DELETE_SELECTED_PAGE_ANIMATION: i18n.t('删除选中页动画'),
    DELETE_ALL_PAGE_ANIMATION: i18n.t('删除所有页动画'),
    MORE_DELETE_OPTION: i18n.t('更多删除选项'),
};
// 批量删除动画二级菜单列表
export const BATCH_DELETE_ANIMATION_MENU_LIST = [
    {
        id: BATCH_DELETE_ANIMATION_MENU_ID.DELETE_SELECTED_ELEMENT_ANIMATION,
        text: BATCH_DELETE_ANIMATION_MENU_TEXT.DELETE_SELECTED_ELEMENT_ANIMATION,
    },
    {
        id: BATCH_DELETE_ANIMATION_MENU_ID.DELETE_SELECTED_PAGE_ANIMATION,
        text: BATCH_DELETE_ANIMATION_MENU_TEXT.DELETE_SELECTED_PAGE_ANIMATION,
    },
    {
        id: BATCH_DELETE_ANIMATION_MENU_ID.DELETE_ALL_PAGE_ANIMATION,
        text: BATCH_DELETE_ANIMATION_MENU_TEXT.DELETE_ALL_PAGE_ANIMATION,
    },
    {
        id: BATCH_DELETE_ANIMATION_MENU_ID.MORE_DELETE_OPTION,
        text: BATCH_DELETE_ANIMATION_MENU_TEXT.MORE_DELETE_OPTION,
    },
];
// 删除动画弹窗标题
export const DELETE_ANIMATION_TITLE = i18n.t('批量删除动画');
// 删除页面范围标题
export const DELETE_SLIDE_RANGE_TITLE = i18n.t('删除页面范围');
// 删除动画类型标题
export const DELETE_ANIMATION_TYPE_TITLE = i18n.t('删除动画类型');
// 删除页面范围类型
export enum DELETE_SLIDE_RANGE_TYPE {
    ALL_SLIDE = 1,
    SELECTED_ELEMENT_ANIMATION = 2,
    SELECTED_SLIDE_ANIMATION = 3,
}
// 删除页面范围文本
export const DELETE_SLIDE_RANGE_TEXT = {
    allSlide: i18n.t('所有页动画'),
    selectedElementsAnimation: i18n.t('选中元素动画'),
    currentSlide: i18n.t('选中页动画'),
};
// 删除页面范围列表
export const DELETE_SLIDE_RANGE_LIST = [
    { value: DELETE_SLIDE_RANGE_TYPE.ALL_SLIDE, text: DELETE_SLIDE_RANGE_TEXT.allSlide },
    {
        value: DELETE_SLIDE_RANGE_TYPE.SELECTED_ELEMENT_ANIMATION,
        text: DELETE_SLIDE_RANGE_TEXT.selectedElementsAnimation,
    },
    { value: DELETE_SLIDE_RANGE_TYPE.SELECTED_SLIDE_ANIMATION, text: DELETE_SLIDE_RANGE_TEXT.currentSlide },
];
// 默认删除动画类型复选项
export const DEFAULT_DELETE_ANIM_TYPE_CHECKBOX_LIST = [
    STTLTimeNodePresetClassType.entr,
    STTLTimeNodePresetClassType.exit,
    STTLTimeNodePresetClassType.emph,
    STTLTimeNodePresetClassType.path,
];
// 删除动画类型
export enum DELETE_ANIM_TYPE {
    REMOVE_ENTRANCE = 1,
    REMOVE_EXIT = 2,
    REMOVE_EMPHASIS = 3,
    REMOVE_PATH = 4,
    RETAIN_AUDIO_AND_VIDEO_ANIMATION = 6,
}
// 删除动画类型文本
export const DELETE_ANIM_TEXT = {
    removeEntrance: i18n.t('进入'),
    removeExit: i18n.t('退出'),
    removeEmphasis: i18n.t('强调'),
    removePath: i18n.t('路径'),
    retainAudioAndVideoAnimation: i18n.t('音视频'),
};
// 复选框页面显示
export const DELETE_ANIM_TYPE_CHECKBOX_LIST = [
    { value: DELETE_ANIM_TYPE.REMOVE_ENTRANCE, text: DELETE_ANIM_TEXT.removeEntrance },
    { value: DELETE_ANIM_TYPE.REMOVE_EMPHASIS, text: DELETE_ANIM_TEXT.removeEmphasis },
    { value: DELETE_ANIM_TYPE.REMOVE_EXIT, text: DELETE_ANIM_TEXT.removeExit },
    { value: DELETE_ANIM_TYPE.REMOVE_PATH, text: DELETE_ANIM_TEXT.removePath },
    { value: DELETE_ANIM_TYPE.RETAIN_AUDIO_AND_VIDEO_ANIMATION, text: DELETE_ANIM_TEXT.retainAudioAndVideoAnimation },
];
// 用户不勾选默认删除动画配置项
export const DEFAULT_DELETE_LIST = [
    STTLTimeNodePresetClassType.entr,
    STTLTimeNodePresetClassType.exit,
    STTLTimeNodePresetClassType.emph,
    STTLTimeNodePresetClassType.path,
    STTLTimeNodePresetClassType.mediacall,
];
// 批量添加动画弹窗标题
export const BATCH_ANIMATION_TITLE = i18n.t('批量添加动画');
// 添加页面范围标题
export const ADD_SLIDE_RANGE_TITLE = i18n.t('添加页面范围');
// 添加动画风格标题
export const ADD_ANIMATION_STYLE_TITLE = i18n.t('添加动画风格');
// 添加动画类型标题
export const ADD_ANIMATION_TYPE_TITLE = i18n.t('添加动画类型');
// 添加页面范围单选框值
export const ADD_SLIDE_RANGE_TYPE_VALUE = {
    ADD_ALL_SLIDE_ANIM: 'add_all_slide_anim',
    ADD_SELECTED_SLIDE_ANIM: 'add_selected_slide_anim',
};
// 添加页面范围单选框文本
export const ADD_SLIDE_RANGE_TYPE_TEXT = {
    ADD_ALL_SLIDE_ANIM: i18n.t('添加所有页动画'),
    ADD_SELECTED_SLIDE_ANIM: i18n.t('添加选中页动画'),
};
// 添加页面范围单选框列表
export const ADD_SLIDE_RANGE_TYPE_LIST = [
    { value: ADD_SLIDE_RANGE_TYPE_VALUE.ADD_ALL_SLIDE_ANIM, text: ADD_SLIDE_RANGE_TYPE_TEXT.ADD_ALL_SLIDE_ANIM },
    {
        value: ADD_SLIDE_RANGE_TYPE_VALUE.ADD_SELECTED_SLIDE_ANIM,
        text: ADD_SLIDE_RANGE_TYPE_TEXT.ADD_SELECTED_SLIDE_ANIM,
    },
];
// 添加动画风格值
export const ADD_ANIMATION_TYPE_VALUE = {
    SIMPLE_AND_FASHIONABLE: 'simple_and_fashionable',
    UNIFIED_STYLE: 'unified_style',
    SMART_JUMP: 'smart_jump',
};
// 添加动画风格文本
export const ADD_ANIMATION_TYPE_TEXT = {
    SIMPLE_AND_FASHIONABLE: i18n.t('简约风尚'),
    UNIFIED_STYLE: i18n.t('统一风格'),
    SMART_JUMP: i18n.t('灵动跳跃'),
};
// 添加动画风格列表
export const ADD_ANIMATION_TYPE_LIST = [
    { value: ADD_ANIMATION_TYPE_VALUE.SIMPLE_AND_FASHIONABLE, text: ADD_ANIMATION_TYPE_TEXT.SIMPLE_AND_FASHIONABLE },
    { value: ADD_ANIMATION_TYPE_VALUE.UNIFIED_STYLE, text: ADD_ANIMATION_TYPE_TEXT.UNIFIED_STYLE },
    { value: ADD_ANIMATION_TYPE_VALUE.SMART_JUMP, text: ADD_ANIMATION_TYPE_TEXT.SMART_JUMP },
];
// 简约时尚动画策略
export const SIMPLE_AND_FASHIONABLE_STRATEGY = [
    AnimType.FadeIn, AnimType.Spread, AnimType.FlyIn, AnimType.EntrBlinds, AnimType.FloatUpIn,
];
// 灵动跳跃动画除图片和表格外策略动画图片和表格策略
export const SMART_JUMP_PICTURE_AND_TABLE_STRATEGY = [
    [AnimType.FadeIn, AnimType.EntrGrowTurn], // 淡入、翻转式旋转
    [AnimType.Spread, AnimType.EntrBasicZoom], // 展开、基本缩放
    [AnimType.FlyIn, AnimType.EntrCenterRevolve], // 飞入、中心旋转
    [AnimType.EntrBlinds, AnimType.EntrPinwheel], // 百叶窗、玩具风车
    [AnimType.FloatUpIn, AnimType.EntrRiseUp], // 浮入、升起
];
// 定义元素类型
export const CUSTOM_ELEMENT_TYPE = {
    TEXT: 'Text',
    SHAPE: 'Shape',
    OTHER: 'Other',
    IMAGE: 'Image',
    TABLE: 'Table',
};
// 定义元素的类型唯一标识id
export const CUSTOM_ELEMENT_TYPE_VALUE = {
    [CUSTOM_ELEMENT_TYPE.TEXT]: 1, // 文本
    [CUSTOM_ELEMENT_TYPE.SHAPE]: 2, // 形状
    [CUSTOM_ELEMENT_TYPE.OTHER]: 3, // 其它
    [CUSTOM_ELEMENT_TYPE.IMAGE]: 4, // 图像
    [CUSTOM_ELEMENT_TYPE.TABLE]: 5, // 表格
};
// 设置灵动跳跃模式延迟时间
// 图标表格为0.8s 其它为0
export const SMART_JUMP_DELAY = {
    [CUSTOM_ELEMENT_TYPE.IMAGE]: '800',
    [CUSTOM_ELEMENT_TYPE.OTHER]: '0',
};
// 灵动跳跃模式 图片和表格选择animType数组中索引为1值 其余取索引为0值
export enum MODEL_SWITCH {
    OTHER = 0,
    SIMPLE_AND_FASHIONABLE = 1,
}
export enum tdwVer3Type {
    MENU = 1,
    TOOLBAR = 2,
}
export enum toolbarDeleteAnimationValue {
    SELECTED_ELEMENT = 0,
    SELECTED_SLIDE = 1,
    ALL_SLIDE = 2,
}
export enum addSlideAnimationValue {
    ALL_SLIDE = 0,
    SELECTED_SLIDE = 1,
}

export const DELETE_SUCCESS = i18n.t('删除成功');
